export enum LoaderScriptDataAttributes {
  AUTO_LOAD_DISABLED = 'data-auto-load-disabled',
  FLOW_SYSTEM_ID = 'data-flow-system-id',
  VARIANT = 'data-variant',
  WIDGET_ID = 'data-widget-id',
  SHOW_STATE_DEBUGGER = 'data-show-state-debugger',
  PARENT_ELEMENT_ID = 'data-parent-element-id',
  LANGUAGE = 'data-language',
}
